import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    component: () => import("./views/HomePage.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("./views/AboutUpp.vue"),
  },
  {
    path: "/upp",
    name: "UPP",
    component: () => import("./views/UPP.vue"),
    meta: {
      authRequired: true,
      parentPage: "HomePage",
      searchable: false
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
